$(document).ready(function() {
  $(document).on("change","input[name='updates[]']",function(e) {
    	$(".refresh_btn").closest('form').submit();
    	//console.log('hit');
  });
  $(document).on("click","a.plus_btn,a.minus_btn",function(e) {
    	//console.log("may hit");
    	$(this).closest('li').find("input[name='updates[]']").trigger("change");
  });
});